<template>
  <ul class="leftsidebar">
    <li
        v-for="(item, index) in list"
        :key="index"
        :class="{active: $route.path === item.path}"
        @click="$router.push(item.path)"
        v-show="!item.hide"
    >
      {{ item.title }}
    </li>
  </ul>
</template>

<script>

	import {getLoginStatus} from "@/common/request";

  export default {
		name: 'my-sidebar',
		data() {
      const loginStatus = getLoginStatus();
      const list = [{
        title: '个人信息',
        path: '/my'
      }, {
        title: '我的权益',
        path: '/my-rights',
        hide: !(loginStatus.isLogin && loginStatus.userInfo.member_type === 2)
      }, {
        title: '会员等级',
        path: '/membership-level'
      }, {
        title: '购物车',
        path: '/shopping-cart'
      }, {
        title: '我的订单',
        path: '/my-order'
      }, {
        title: '账户余额',
        path: '/account-balance'
      }, {
        title: '供应商入驻',
        path: '/supplier-settlement'
      }, {
        title: '客服',
        path: '/customer-service'
      }, {
        title: '使用帮助',
        path: '/my-use-help'
      }, {
        title: '设置',
        path: '/set-up'
      }];
			return {
        list,
        loginStatus,
		  };
		},
		mounted() {

		},
		methods: {
		},
	}
</script>

<style scoped>

.leftsidebar {
  width: 100px;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  padding: 20px 0 14px;
  border-radius: 8px;
  background-color: #FFFFFF;
}

.leftsidebar>li {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  margin-bottom: 12px;
}

.leftsidebar>li:last-child {
  margin-bottom: 0;
}

.leftsidebar>li.active {
  color: #333333;
}

.leftsidebar>li.active::after {
  content: "";
  background: linear-gradient(180deg, #FF870E, #FF4F06);
  width: 3px;
  height: 20px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}

</style>
